import React, { useEffect, useState } from "react";
import ConfirmationModal from "../components/modals/ConfirmationModal";
import CustomDurationModal from "../services/calendar-management/components/appointment-types-section/appointment-types-accordion/accordion-body-components/CustomDurationModal";
import ChooseVoiceModal from "../services/your-receptionist/components/receptionist-voice/ChooseVoiceModal";
import ExitModal from "../services/workspace-action-buttons/modals/exit-modal/ExitModal";
import SaveProgressModal from "../services/workspace-action-buttons/modals/save-progress-modal/SaveProgressModal";

const OverlayApp = () => {
  const [dataFromSnippet, setDataFromSnippet] = useState(null);
  const [showOverlay, setShowOverlay] = useState(false);

  // handling progress bar modal
  const [isSaveProgressModalOpen, setIsSaveProgressModalOpen] = useState(false);
  const [currentMessage, setCurrentMessage] = useState("");
  const [currentPercentage, setCurrentPercentage] = useState(0);

  useEffect(() => {
    const handleMessage = (event) => {
      const message = event.data;
      if (message.type === "snippet-to-overlay") {
        setShowOverlay(true);
        setDataFromSnippet(message);

        if (message.childrenType === "save-progress") {
          setIsSaveProgressModalOpen(true);
          setCurrentMessage(message.currentMessage);
          setCurrentPercentage(message.currentPercentage);
        }
      }
    };

    window.addEventListener("message", handleMessage);
    return () => {
      window.removeEventListener("message", handleMessage);
    };
  }, []);

  const sendMessageToSnippet = (extra) => {
    window.parent.postMessage(
      {
        type: "overlay-to-snippet",
        extra: extra,
      },
      "*"
    );
  };

  const closeOverlay = () => {
    const extra = {
      action: "overlay-closed",
    };
    sendMessageToSnippet(extra);
    setShowOverlay(false);
    setDataFromSnippet(null);

    setIsSaveProgressModalOpen(false);
    setCurrentMessage("");
    setCurrentPercentage(0);
  };

  document.body.style.pointerEvents = showOverlay ? "auto" : "none";

  return (
    <>
      {showOverlay && dataFromSnippet && dataFromSnippet.childrenType === "choose-receptionist" && (
        <ChooseVoiceModal
          onClose={closeOverlay}
          onSubmit={(data) => sendMessageToSnippet(data)}
          dataFromSnippet={dataFromSnippet}
          show={showOverlay}
        />
      )}
      {showOverlay && dataFromSnippet && dataFromSnippet.childrenType === "confirmation" && (
        <ConfirmationModal
          onClose={closeOverlay}
          show={showOverlay}
          dataFromSnippet={dataFromSnippet}
          onConfirm={() =>
            sendMessageToSnippet({
              id: dataFromSnippet.id,
              action: "confirm",
              index: dataFromSnippet.index,
            })
          }
          onCancel={closeOverlay}
        />
      )}
      {showOverlay && dataFromSnippet && dataFromSnippet.childrenType === "custom-duration" && (
        <CustomDurationModal
          onClose={closeOverlay}
          show={showOverlay}
          dataFromSnippet={dataFromSnippet}
          onConfirm={(duration) =>
            sendMessageToSnippet({
              id: dataFromSnippet.id,
              duration,
              contactIndex: dataFromSnippet.contactIndex,
              action: "confirm-duration",
            })
          }
          onCancel={closeOverlay}
        />
      )}
      {showOverlay && dataFromSnippet && dataFromSnippet.childrenType === "exit" && (
        <ExitModal
          onClose={closeOverlay}
          show={showOverlay}
          dataFromSnippet={dataFromSnippet}
          onExitWithoutSaving={() =>
            sendMessageToSnippet({ id: dataFromSnippet.id, action: "exit", save: false })
          }
          onExitWithSaving={() =>
            sendMessageToSnippet({ id: dataFromSnippet.id, action: "exit", save: true })
          }
          onCancel={closeOverlay}
        />
      )}

      {showOverlay && dataFromSnippet && dataFromSnippet.childrenType === "save-progress" && (
        <SaveProgressModal
          currentMessage={currentMessage}
          currentPercentage={currentPercentage}
          onClose={closeOverlay}
        />
      )}
    </>
  );
};

export default OverlayApp;
